import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { adminUsersApi, adminCardsApi } from '../../api/client'

export default function DashboardPage() {
  const { data: users = [] } = useQuery({
    queryKey: ['admin-users'],
    queryFn: () => adminUsersApi.list().then(r => r.data),
  })

  const { data: cards = [] } = useQuery({
    queryKey: ['admin-cards'],
    queryFn: () => adminCardsApi.list().then(r => r.data),
  })

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Tableau de bord</h1>
        <Link to="/admin/users/new" className="btn btn-primary">+ Nouvel employé</Link>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="label">Employés</div>
          <div className="value">{users.length}</div>
        </div>
        <div className="stat-card">
          <div className="label">Cartes actives</div>
          <div className="value">{cards.filter(c => c.active).length}</div>
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: '1rem', fontSize: '1.1rem', fontWeight: 600 }}>Derniers employés</h2>
        {users.length === 0 ? (
          <p style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>
            Aucun employé. <Link to="/admin/users/new" style={{ color: '#1a73e8' }}>Créer le premier</Link>
          </p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Poste</th>
                  <th>Email</th>
                  <th>Rôle</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.slice(0, 10).map(user => (
                  <tr key={user.id}>
                    <td><strong>{user.firstName} {user.lastName}</strong></td>
                    <td>{user.jobTitle || '—'}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`badge ${user.roles?.includes('ROLE_ADMIN') ? 'badge-admin' : 'badge-user'}`}>
                        {user.roles?.includes('ROLE_ADMIN') ? 'Admin' : 'Employé'}
                      </span>
                    </td>
                    <td>
                      <Link to={`/admin/users/${user.id}/edit`} className="btn btn-outline btn-sm">Éditer</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
